module.exports = __webpack_public_path__ + "static/media/lifeline_step_6.36098d8d.png";